(function () {
  angular
    .module("akitabox.desktop.room.detail")
    .controller("RoomAssetsTabController", RoomAssetsTabController);

  /* @ngInject */
  function RoomAssetsTabController(
    // Angular
    $scope,
    // Constants
    EVENT_ASSET_CREATE,
    // Services
    AssetService,
    PinService,
    PinValueService,
    ToastService,
    // Resolves
    building,
    room
  ) {
    var self = this;

    // Attributes
    self.building = building;
    self.room = room;
    self.assets = null;
    self.createOptions = getCreateOptions();

    // Functions
    self.fetchAssets = fetchAssets;
    self.fetchAllAssets = fetchAllAssets;

    // ------------------------
    //   Events
    // ------------------------

    $scope.$on(EVENT_ASSET_CREATE, onAssetCreate);

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchAssets(skip, limit) {
      var params = {
        skip: skip,
        limit: limit,
        include_values: true,
        room: self.room._id,
      };

      var options = {
        includePinType: true,
      };

      return AssetService.get(building._id, params, options)
        .then(function (assets) {
          if (angular.isArray(self.assets)) {
            self.assets = self.assets.concat(assets);
          } else {
            self.assets = assets;
          }
          return assets.length;
        })
        .catch(ToastService.showError);
    }

    function fetchAllAssets(limit) {
      var params = {
        skip: 0,
        limit: limit,
        include_values: true,
        room: self.room._id,
      };

      var options = {
        includePinType: true,
      };

      return AssetService.getAll(building._id, params, options)
        .then(function (assets) {
          self.assets = assets;
          return assets.length;
        })
        .catch(ToastService.showError);
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function getCreateOptions() {
      return {
        locals: {
          building: building,
          room: room,
        },
      };
    }

    /**
     * Handle asset creation event
     *
     * @param {Event}   $event    Angular event
     * @param {Asset[]} assets    List of new assets
     */
    function onAssetCreate($event, assets) {
      // We can only create one asset at a time
      var asset = assets[0];
      var roomId = PinValueService.getRoomId(asset.values);
      if (roomId === self.room._id) {
        PinService.includePinType(asset.building, [asset]).then(function (
          results
        ) {
          if (!self.assets) {
            self.assets = [];
          }
          self.assets.unshift(results[0]);
        });
      }
    }
  }
})();
